import api from '../../plugins/api';

const getLeadStatuses = (params) => {
  return api.get('/api/crm/leads/getLeadStatuses', params);
};

export default getLeadStatuses;
